import { useEffect, useRef, RefObject } from 'react';

const useClickOutside = (callback: () => void): RefObject<HTMLDivElement> => {
  const elementRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    document.addEventListener('mousedown', handleClickOutside);
    document.addEventListener('keydown', handleKeyDown);
    // cleanup
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
      document.removeEventListener('keydown', handleKeyDown);
    };
  }, []);

  const handleClickOutside = (e:MouseEvent) => {
    // closes the dialog on click outside
    if (!elementRef.current?.contains(e.target as Node)) {
      callback();
    }
  };

  const handleKeyDown = (e:KeyboardEvent) => {
    // closes the dialog when the user presses ESC
    if('Escape' === e.code) {
      callback();
    }
  };

  return elementRef;
};

export default useClickOutside;
